<template>
  <b-form-group :label="label" :label-for="`tags-${_uid}`">
    <v-select
      :input-id="`tags-${_uid}`"
      :value="value"
      :options="options"
      :reduce="tag => tag.tagId"
      :selectable="tag => value.includes(tag.tagId) || value.length < 10"
      :loading="loading"
      :disabled="loading || Boolean(error)"
      multiple
      label="title"
      placeholder="انتخاب تگ‌ها"
      @input="$emit('input', $event)"
    >
      <template #no-options>تگی پیدا نشد؛ ابتدا در مدیریت تگ‌ها آن را بسازید.</template>
    </v-select>
    <small class="d-block text-muted mt-50">اختیاری؛ حداکثر ۱۰ تگ. با خالی کردن این فهرست، تگ‌ها نمایش داده نمی‌شوند.</small>
    <small v-if="error" class="d-block text-danger" role="alert">{{ error }}</small>
    <div class="mt-50">
      <b-link :to="{ name: 'pages-tags' }" target="_blank">مدیریت تگ‌ها</b-link>
      <b-button size="sm" variant="outline-secondary" class="ml-1" :disabled="loading" @click="loadTags">بازخوانی تگ‌ها</b-button>
    </div>
  </b-form-group>
</template>

<script>
import { BButton, BFormGroup, BLink } from 'bootstrap-vue'
import vSelect from 'vue-select'
import { tagRequest } from '@/libs/Api/Tag'

export default {
  components: { BButton, BFormGroup, BLink, vSelect },
  props: {
    value: { type: Array, default: () => [] },
    label: { type: String, default: 'تگ‌های نمایشی' },
  },
  data() { return { options: [], loading: false, error: '' } },
  created() { this.loadTags() },
  methods: {
    async loadTags() {
      this.loading = true
      this.error = ''
      try {
        this.options = await tagRequest(this, 'GetAll')
      } catch (error) {
        this.error = error.message || 'دریافت تگ‌ها انجام نشد.'
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
